import {Form, Input, Switch} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import IconPicker from "../../../../../shared/IconPicker";
import TextColorPicker from "../../../../../shared/textColorPicker/TextColorPicker";
import LocaleText from "../../../../settings/dictionary/LocaleText";

export interface IFieldBase64Options {
    addSignatureWaterMark?: boolean;
    allowSavedSignature?: boolean;
}

interface IProps extends IFieldOptionsEditorProps {

}

class FieldBase64OptionsEditor extends React.Component<IProps> {

    render() {
        const {buildFieldName} = this.props
        return (
            <div>
                <Form.Item name={buildFieldName('addSignatureWaterMark')} label={<LocaleText code={'configuration.field.base64.option.signature-water-mark'} fallback={'Přidat uživatelské jméno a čas podpisu jako vodoznak'}/>} initialValue={true} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
                <Form.Item name={buildFieldName('allowSavedSignature')} label={<LocaleText code={'configuration.field.base64.option.allow-saved-signature'} fallback={'Povolit použití uloženého podpisu'}/>} valuePropName={'checked'} initialValue={true}>
                    <Switch/>
                </Form.Item>
            </div>
        )
    }
}


export default FieldBase64OptionsEditor